import React from 'react';
import EmployerDashboardNav from "../../employer/EmployerDashboardNav";
import {useLocation} from "react-router";
import Breadcrumb from '../../Breadcrumb';
import DOMPurify from 'dompurify';
const JobDetailsPage = () => {
  const { state } = useLocation();
  const job = state?.job;

  if (!job) {
    return (
      <div className="col-lg-9">
        <div className="job-details-container">
          <p>Loading job details...</p>
        </div>
      </div>
    );
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  const stripHtml = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  // Function to sanitize HTML but keep safe tags
  const sanitizeHtml = (html) => {
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'p', 'br', 'ul', 'ol', 'li'],
      ALLOWED_ATTR: [], // No attributes allowed
    });
  };

  // Choose which content should allow HTML and which shouldn't
  const renderContent = (content, allowHtml = false) => {
    if (!content) return null;

    if (allowHtml) {
      const sanitized = sanitizeHtml(content);
      return <div dangerouslySetInnerHTML={{__html: sanitized}}/>;
    }

    return <p>{stripHtml(content)}</p>;
  };

  return (
    <>
      <Breadcrumb
        title="Manage Jobs"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Manage Jobs", active: true }
        ]}
      />
      <div className='user-profile py-120'>
        <div className='container'>
          <div className='row'>
            <EmployerDashboardNav/>
            <div className="col-lg-9">
              <div className="job-details-container">
                <div className="job-header">
                  <div className="d-flex justify-content-between align-items-center">
                    <h1 className="job-title-detail">{job.job_name}</h1>
                    <span className={`status-badge ${job.job_status ? 'active' : 'inactive'}`}>
                      {job.job_status ? "Active" : "Inactive"}
                    </span>
                  </div>
                  <div className="company-info">
                    <h3>{job.company_name}</h3>
                    <p>Posted on: {formatDate(job.post_date)}</p>
                  </div>
                </div>

                <div className="row job-quick-info">
                  <div className="col-md-6">
                    <div className="info-card">
                      <div className="info-item">
                        <i className="far fa-building"></i>
                        <span>Department: {job.department}</span>
                      </div>
                      <div className="info-item">
                        <i className="far fa-location-dot"></i>
                        <span>Location: {job.city || "Not Available"}</span>
                      </div>
                      <div className="info-item">
                        <i className="far fa-briefcase"></i>
                        <span>Job Type: {job.job_type}</span>
                      </div>
                      <div className="info-item">
                        <i className="far fa-money-bill"></i>
                        <span>
                          Package: {job.package ? job.package : 'Not Disclosed'}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="info-card">
                      <div className="info-item">
                        <i className="far fa-graduation-cap"></i>
                  <span>Qualification: {job.qualification}</span>

                      </div>
                      <div className="info-item">
                        <i className="far fa-clock"></i>
                        <span>Experience: {job.experience}</span>
                      </div>
                      <div className="info-item">
                        <i className="far fa-users"></i>
                        <span>Positions: {job.number_of_positions}</span>
                      </div>
                      <div className="info-item">
                        <i className="far fa-user-tie"></i>
                        <span>HR: {job.hr_name || 'Not specified'}</span>
                      </div>
                      {/* <div className="info-item">
                        <i className="far fa-envelope"></i>
                        <span>Email: {job.email || 'Not specified'}</span>
                      </div> */}
                    </div>
                  </div>
                </div>

                <div className="section">
                  <h2 className="section-title">Role Overview</h2>
                  <p>{job.job_name}</p>
                </div>

                <div className="section">
                  <h2 className="section-title" >Job Description</h2>
                  <p>{renderContent(job.job_description, true)}</p>
                </div>
                {
                  job.job_highlights && <div className="section">
                  <h2 className="section-title">Job Highlights</h2>
                  <p>{renderContent(job.job_highlights, true)}</p>
                </div>
                }

                <div className="section">
                  <h2 className="section-title">Required Skills</h2>
                  <div className="skills-container cursor-pointer">
                    {(() => {
                      let skills = [];

                      if (typeof job.skills === 'string') {
                        try {
                          skills = JSON.parse(job.skills);
                        } catch (e) {
                          console.error('Invalid JSON in job.skills:', e);
                        }
                      } else if (Array.isArray(job.skills)) {
                        skills = job.skills;
                      }

                      return skills.length > 0 ? (
                        skills.map((skill) => (
                          <span key={skill.skill_id || skill} className="skill-badge">
                            {skill.skill_name || skill}
                          </span>
                        ))
                      ) : (
                        <p>No skills specified</p>
                      );
                    })()}
                  </div>

                </div>

                {/* {job.job_external_url && (
                  <div className="section">
                    <h2 className="section-title">External Application</h2>
                    <a href={job.job_external_url} className="btn btn-primary-detail" target="_blank" rel="noopener noreferrer">
                      Apply Externally
                    </a>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobDetailsPage;